// Function to Display Error Message if Issue with API Call
const ErrorMessage = () => {
    return <p className="errorMessage">Oops! Looks like getting inspiration will not be so instant... Please try again a little later.</p>
}

export default ErrorMessage;